<template>
  <CheckVerifyToken />
</template>

<script>
import CheckVerifyToken from "../../components/login/checkVerifyToken";
export default {
  components: {
    CheckVerifyToken,
  },
};
</script>

